module.exports = __webpack_public_path__ + "img/41.ed5206aa.png";